const MAX_FEE_INTEGER_DIGITS = 6;
const MAX_FEE_DECIMAL_DIGITS = 2;

/**
 * Fee input: digits and a single dot as decimal separator (no commas).
 * Up to 6 integer digits and 2 decimal places (cents).
 */
export function sanitizeFeeInput(fee: string): string {
  let value = fee.replace(/^\$/, "").trim().replace(/,/g, "");
  value = value.replace(/[^0-9.]/g, "");

  if (value.startsWith(".")) {
    value = `0${value}`;
  }

  const dotIndex = value.indexOf(".");
  if (dotIndex !== -1) {
    value =
      value.slice(0, dotIndex + 1) +
      value.slice(dotIndex + 1).replace(/\./g, "");
  }

  const endsWithDot = value.endsWith(".");
  const [rawInt = "", rawDec = ""] = value.split(".");

  let intPart = rawInt.slice(0, MAX_FEE_INTEGER_DIGITS);
  if (intPart.length > 1 && intPart.startsWith("0")) {
    intPart = intPart.replace(/^0+/, "") || "0";
  }

  const decPart = rawDec.slice(0, MAX_FEE_DECIMAL_DIGITS);

  if (dotIndex !== -1) {
    if (endsWithDot && decPart.length === 0) {
      return `${intPart}.`;
    }
    return decPart.length > 0 ? `${intPart}.${decPart}` : intPart;
  }

  return intPart;
}

export function normalizeFeeOnBlur(fee: string): string {
  const withoutTrailingDot = fee.replace(/\.$/, "");
  const sanitized = sanitizeFeeInput(withoutTrailingDot);
  if (!sanitized) return "0";
  const num = parseFloat(sanitized);
  if (Number.isNaN(num)) return "0";
  return String(num);
}

/** Display/API number as fee field text (always uses dot, never locale comma). */
export function formatFeeNumberForInput(fee: number): string {
  if (!Number.isFinite(fee)) return "0";
  return String(fee);
}
